module.exports = __webpack_public_path__ + "static/media/project-thumbnail16.36a6e547.jpg";